import QueryString from 'qs';
import xhr from 'xhr';
import Config from 'Config';

import Collection from 'lib/Collection';
import FaqSection from 'entities/FaqSection';

const URL = Config.Environment.R101_ZENDESK_URL;

// @ts-expect-error ts-migrate(2417) FIXME: Class static side 'typeof FaqSections' incorrectly... Remove this comment to see the full error message
export default class FaqSections extends Collection<FaqSection> {
  initialize() {
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof FaqSection' is missing the following ... Remove this comment to see the full error message
    this.model = FaqSection;
  }

  parse(response: any) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'section' implicitly has an 'any' type.
    return response.map((section) => FaqSection.fromJSON(section));
  }

  // $FlowFixMe missing annotation
  static fetch(options = {}) {
    // $FlowFixMe missing annotation
    return new Promise((resolve, reject) => {
      xhr(
        {
          url: `${URL}/api/v2/help_center/sections?` + QueryString.stringify(options),
          method: 'GET',
        },
        (err, response, body) => {
          let possiblyParsedBody = body;
          try {
            possiblyParsedBody = JSON.parse(body);
          } catch (e) {
            // Do nothing.
          }

          if (err || response.statusCode >= 400) {
            // TODO: Wrap the error response into something easier to use.
            reject(err || possiblyParsedBody || body);
          } else {
            // $FlowFixMe
            resolve(this.fromJSON(possiblyParsedBody.sections));
          }
        }
      );
    });
  }
}
